
export const Priority = Object.freeze({
    LOW: 1,
    MEDIUM: 2,
    HIGH: 3,
});

export const Progress = Object.freeze({
    NO_PROGRESS: 1,
    IN_PROGRESS: 2,
    COMPLETED: 3,
    ARCHIVE: 4,
});

export const Months = Object.freeze({
    JANUARY: 1,
    FEBRUARY: 2,
    MARCH: 3,
    APRIL: 4,
    MAY: 5,
    JUNE: 6,
    JULY: 7,
    AUGUST: 8,
    SEPTEMBER: 9,
    OCTOBER: 10,
    NOVEMBER: 11,
    DECEMBER: 12,
});

export const Stage = Object.freeze({
    NOT_STARTED: 'Not Started',
    STARTED: 'Started',
    UNCOMPLETED: 'Uncompleted',
    COMPLETED: 'Completed',
    PAUSED: 'Paused',
    REVIEW: 'Review'
});


export const ResponseCheckList = () => {
    return [
        { name: 'YES', value: 'Yes' },
        { name: 'NO', value: 'No' },
    ];
};
